import { styled } from "goober";
import { PageSurface } from "../PageBody";

export const ChatPageSurface = styled(PageSurface)`
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  background: var(--surface-primary);
  outline: 0.5px solid var(--border-alpha);
  border-radius: 16px;
  box-shadow: var(--elevation-low);
  overflow: hidden;
`;
